export default {
  'AdditionalOrderRow.Button': ({ }, outlet) => {
    outlet({ action: 'view_order' });
  }
}